// extracted by mini-css-extract-plugin
module.exports = {"TabNavigation":"TabNavigation--3CaCL","ToFollowUpBadge":"ToFollowUpBadge--3Ps-n"};